import type { Aviso } from "@/components/design-new/toast"

/**
 * Copia para a área de transferência, com a saída antiga para o navegador que
 * não dá a API nova (WebView antiga, página fora de HTTPS). Devolve se copiou, e
 * nunca rejeita.
 *
 * Quem confirma ("Link copiado", o check no botão) confirma SÓ com o `true`
 * (27/10/2026). A escrita pode ser recusada (permissão negada, aba sem foco, o
 * Safari depois de uma espera), e vinte botões confirmavam sem conferir: a pessoa
 * ia colar o link no WhatsApp, ou o Pix no app do banco, e não havia nada lá.
 */
export async function copiarTexto(texto: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto)
      return true
    }
  } catch {
    /* cai na saída antiga, abaixo */
  }
  const antes = document.activeElement instanceof HTMLElement ? document.activeElement : null
  try {
    const area = document.createElement("textarea")
    area.value = texto
    area.setAttribute("readonly", "")
    area.style.position = "fixed"
    area.style.opacity = "0"
    /* Dentro do popup aberto, e não no fim da página: o popup prende o foco nele,
       e o campo de fora perderia a seleção antes de copiar. */
    ;(antes?.closest('[role="dialog"]') ?? document.body).appendChild(area)
    area.select()
    const ok = document.execCommand("copy")
    area.remove()
    return ok
  } catch {
    return false
  } finally {
    /* O foco volta ao botão que copiou, e não ao começo da página. */
    antes?.focus({ preventScroll: true })
  }
}

/**
 * O aviso de quando não copiou, o mesmo em toda tela: o que houve e o que fazer.
 * Onde o texto copiado NÃO está à vista (o link de pagar de uma linha da lista),
 * quem chama troca o `apoio` por um com o próprio texto.
 */
export const AVISO_NAO_COPIOU: Omit<Aviso, "id"> = {
  tom: "erro",
  titulo: "Não deu para copiar",
  apoio: "Toque e segure no texto para copiar à mão.",
}
